import type { GroupProps } from './group.types';
import clsx from 'clsx';
import GROUP_TYPE from '@/components/landing-page/utils/prio-group-type';
import { cn } from '@/utils/helper';
import v1 from './group-v1.module.css';
import v2 from './group-v2.module.css';

const Group = (props: GroupProps) => (
  <div className={props.groupClassName}>
    {props.group.content.head ? <div className={props.titleClassName}>{props.group.content.head()}</div> : null}
    {props.group.content.body ? (
      <div
        className={clsx(props.blockClassName, {
          [cn(v1.Question, v2.Question)]: props.group.type === GROUP_TYPE.QUESTION,
        })}
      >
        {props.group.type === GROUP_TYPE.QUESTION ? props.group.content.body() : props.group.content.body()}
      </div>
    ) : null}
  </div>
);

export default Group;
